import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

import { IShipmentSearchCriteria } from '@project44-models/shipment-list';

export type TChat = {
  chatResponse: string;
  discussionId: string;
  id: string;
  role: string;
  shipmentFilter?: {
    name: string;
    filterCriteria: IShipmentSearchCriteria;
  };
};

export type TFetchChats = {
  discussionId: string;
  id: string;
  inputHistory: string[];
  role: string;
};

export async function fetchChats(payload: TFetchChats): Promise<TChat> {
  const { data } = await axios.post(
    `${BASE_URL}/movement-chatbot/chat-completion`,
    payload,
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return data;
}
